module.exports = __webpack_public_path__ + "media/application/images/demo/adv_960x90-28bd1a5a37bb870fec57df80ea454774.jpg";